export default __webpack_public_path__ + "static/stk-praha-rozvrh-31011a477271deaa94f5ac6fc2dfd36b.pdf";